export const WorkplaceTypes = {
    Baltika: 'Baltika',
    Slavutich: 'Slavutich',
    Alivaria: 'Alivaria',
    Derbes: 'Derbes'
}